import React, { useState } from "react";
import { Button, Menu } from "@mantine/core";
import { useServerApi } from "../hooks/userServerApi";

import { showNotification } from "@mantine/notifications";
import {
  IconCircleCheck,
  IconExclamationMark,
  IconChevronDown,
} from "@tabler/icons";
import { useTranslation } from "react-i18next";
import { openFileUrl } from "../utils/openReport";

const QuotationConfirmButton = ({ mainForm, disabled = false }) => {
  const [api] = useServerApi();
  const { _id: id } = mainForm.values;
  const { t: translate } = useTranslation();
  const [loading, setLoading] = useState(false);

  const confirm = async (format = "pdf") => {
    try {
      setLoading(true);
      const result = await api.Quotation.confirm(id, format);

      if (!result?.success) {
        throw result?.error;
      }

      if (result?.data?.url) {
        await openFileUrl(result.data.url);
        showNotification({
          title: translate("Confirmation Letter Generated"),
          color: "blue",
          icon: <IconCircleCheck size={18} />,
          message: translate("The confirmation letter has been generated."),
        });
      } else {
        showNotification({
          title: translate("Confirm Error"),
          color: "red",
          icon: <IconExclamationMark size={18} />,
          message: translate("No confirmation letter was generated."),
        });
      }
    } catch (error) {
      showNotification({
        title: `Confirm Error`,
        color: "red",
        icon: <IconExclamationMark size={18} />,
        message: error,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Menu shadow="md" width={200} withinPortal>
        <Menu.Target>
          <Button
            fullWidth
            color="blue"
            disabled={disabled}
            loading={loading}
            rightIcon={<IconChevronDown size={16} />}
            styles={{
              inner: { position: "relative", justifyContent: "center" },
              label: {
                flex: 1,
                width: "100%",
                justifyContent: "center",
                paddingRight: 28,
              },
              rightIcon: {
                position: "absolute",
                right: 12,
                top: "50%",
                transform: "translateY(-50%)",
                marginLeft: 0,
              },
            }}
          >
            {loading
              ? translate("Printing")
              : translate("Print Confirmation Letter")}
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            onClick={() => confirm("pdf")}
            disabled={disabled || loading}
          >
            PDF
          </Menu.Item>
          <Menu.Item
            onClick={() => confirm("word")}
            disabled={disabled || loading}
          >
            Word
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
  );
};

export default QuotationConfirmButton;
